/* eslint-disable camelcase */
import VueRouter from 'vue-router';

import { List, View, Main, ThreatRadar } from '@/views/vulnfeed/detections';
import * as errors from '../views/errors';

const getRoutes = ({ sidebar, showApckReportedCheck }) => ([
    {
        name: 'root',
        path: '/',
        component: Main,
        icon: 'fa-area-chart',
        title: 'Detections',
        redirect: {
            name: 'threatradar',
        },
    },
    {
        name: 'threatradar',
        path: '/threat-radar/',
        component: ThreatRadar,
        icon: 'fa fa-gauge',
        title: 'Threat Radar',
        meta: {
            scanner_nav_only: true,
            no_sidebar: !sidebar,
            public: false,
        },
        children: [],
    },
    {
        name: 'kev-widget',
        path: '/kev-widget',
        component: () =>
        import(/* webpackChunkName: "kev-widget" */ '@/views/vulnfeed/widgets/KevWidget.vue'),
        title: 'KEV Widget',
        hide_navigation: true,
        meta: {
            no_sidebar: true,
        },
    },
    {
        name: 'carousel-widget',
        path: '/carousel-widget',
        component: () =>
        import(/* webpackChunkName: "carousel-widget" */ '@/views/vulnfeed/widgets/CarouselWidget.vue'),
        title: 'Carousel Widget',
        hide_navigation: true,
        meta: {
            no_sidebar: true,
        },
    },
    {
        name: 'top-vendors-widget',
        path: '/top-vendors-widget',
        component: () =>
        import(/* webpackChunkName: "top-vendors-widget" */ '@/views/vulnfeed/widgets/TopVendorsWidget.vue'),
        title: 'Top Vendors Widget',
        hide_navigation: true,
        meta: {
            no_sidebar: true,
        },
    },
    {
        name: 'vulnerabilities.list',
        path: '/vulnerabilities/list',
        alias: ['/v/list', '/vulnerabilities', '/v'],
        component: List,
        icon: 'fa-bug',
        title: 'Vulnerabilities',
        meta: {
            scanner_nav_only: true,
            no_sidebar: !sidebar,
        },
        props: (route) => ({ showApckReportedCheck, has_kev__eq: route.query.has_kev__eq === 'true' }),
        hide_navigation: false,
    },
    {
        name: 'vulnerabilities.view',
        path: '/vulnerabilities/view/:vuln_id',
        alias: ['/v/view/:vuln_id'],
        component: View,
        title: 'Vulnerability',
        hide_navigation: true,
    },
    {
        name: 'vulnerabilities.show-default',
        path: '/v/:vuln_id(\\d+)',
        component: View,
        title: 'Vulnerability (ID)',
        hide_navigation: true,
    },
    {
        name: 'vulnerabilities.show-default-cve',
        path: '/v/:vuln_id([A-Za-z][A-Za-z0-9_-]*)',
        component: View,
        title: 'Vulnerability (CVE)',
        hide_navigation: true,
    },
    {
        name: 'vulnerabilities.show-default-cve-no-prefix',
        path: '/:vuln_id(cve[-_0-9]+)',
        component: View,
        title: 'Vulnerability (CVE+)',
        hide_navigation: true,
    },
    {
        name: 'vulnerabilities.show-default-id-no-prefix',
        path: '/:vuln_id(\\d+)',
        component: View,
        title: 'Vulnerability (CVE+)',
        hide_navigation: true,
    },
    {
        name: '404',
        path: '*',
        component: errors.NotFound,
        meta: {
            // do we want one?
            no_sidebar: true,
        },
    },
]);

export const getRouter = ({ sidebar, showApckReportedCheck }) => {
    const routes = getRoutes({ sidebar, showApckReportedCheck });
    const router = /* #__PURE__ */ new VueRouter({
        mode: 'history',
        base: '/',
        linkExactActiveClass: 'active',
        tree: routes,
        routes,
    });
    return router;
};
